<script setup>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import {ref, defineExpose, getCurrentInstance} from "vue";
import {useRoute, useRouter} from 'vue-router'
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import jobFairUserService from "../../../services/jobFair/jobFairUserService";
import jobFairCorpService from "../../../services/jobFair/jobFairCorpService";
import MyPageCorpJobFairCorpInfoView from "../../../views/mypage/corpJobFair/MyPageCorpJobFairCorpInfoView.vue";
import jobFairGnbService from "@/pages/user/services/jobFair/jobFairGnbService";
import JobFairJobNoticeModal from "@/pages/user/components/modal/jobFair/JobFairJobNoticeModal.vue";
import { useAlertStore } from "../../../../../stores/alertStore";
import mypageCorpInfoService from "@/pages/user/services/mypage/mypageCorpInfoService";
import {storeToRefs} from "pinia";
import {useUserStore} from "@/pages/user/stores/user";
import {useNavigationStore} from "@/stores/navigation";
import UserMatchingResumeCreateModal from "@/pages/user/components/modal/mypage/UserMatchingResumeCreateModal.vue";
import {value} from "lodash/seq";
import mypageUserResumeService from "@/pages/user/services/mypage/mypageUserResumeService";
const { $alert, $confirm } = useAlertStore();

const userStore = useUserStore();
const { isAuthenticated } = storeToRefs(userStore);

const route = useRoute();
const router = useRouter();
const loadingStore = usePageLoadingStore()
const navigationStore = useNavigationStore();
const { $pageListBoardNo } = getCurrentInstance().appContext.config.globalProperties;

const jobNoticeList = ref([]);
const currentPage = ref(1);
const pageSize = 5;
const totalPages = ref(1);
const totalCount = ref(0);

const baseModal = ref(null);
const resolvePromise = ref(null);
const jobNoticeModal = ref(null); // 채용공고 보기
const userMatchingResumeCreateModal = ref(null); // 이력서 목록 보기

const modalBody = ref(null)
const modalContent = ref([])

const showButtons = ref(false);
const showPropsButtons = ref(false);
const corpLikeTxts = ref("♡관심기업");
const ojfIds = ref(0);
const corpIds = ref(0);
const jobNoticeSeqs = ref(0);
const commonDatas = ref('N'); // 구직자: 면접제안 여부 / 기업: 사용자의 회사아이디
const masterYns = ref('N'); // 마스터 여부
const modes = ref('');
const userIds = ref('');
const viewSources = ref('');
const userTypes = ref('');
const apllyYns = ref('N'); // 입사지원 여부
const jobNotice = ref(true);

const props = defineProps({
  inactiveInnerModal: {
    type: Boolean,
    default: false,
  },
});

const resetPromotionState = () => {
  apllyYns.value = 'N';
}

// 기업 정보
const ojfCorporationDetail = (corpId) => {
  loadingStore.loading = true;
  jobFairCorpService.ojfCorporationDetail(corpId)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          modalBody.value.setCorpInfo(result);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 기업 정보 - 기업홍보관
const retrieveCorporation = (corpId, userId, viewSource, userType) => {
  corpIds.value = corpId;
  userIds.value = userId;
  viewSources.value = viewSource;
  userTypes.value = userType;

  loadingStore.loading = true;
  mypageCorpInfoService.retrieveCorporation(corpId)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          modalBody.value.setCorpInfo(result);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 상시채용관 기업정보
const matchingCorporationDetail = (corpId) => {
  // 채용공고 안보이게 하드코딩
  viewSources.value = 'promotion';

  loadingStore.loading = true;
  mypageUserResumeService.retrieveCorporation(corpId)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          modalBody.value.setCorpInfo(result);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 기업정보 보기 팝업의 채용공고 리스트
const ojfGnbCorpInfoJobNoticeList = (corpId, ojfId) => {
  corpIds.value = corpId;
  ojfIds.value = ojfId;

  loadingStore.loading = true;
  let paramObj = {
    ojfId: ojfId,
    corpId: corpId,
    pageNumber: currentPage.value,
    size: pageSize,
  }
  jobFairGnbService.ojfGnbCorpInfoJobNoticeList(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          jobNoticeList.value = $pageListBoardNo(result.content, totalCount.value, pageSize, currentPage.value);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 기업정보 수정
const onClickCorpUpdate = (ojfId, mode) => {
  if (mode === 'openRecruitment') {
    router.push({name: 'MyPageCorpOpenRecruitmentDetail', params:{id: ojfId, mode: mode}})
  } else {
    router.push({name: 'MyPageCorpJobFairDetail', params:{id: ojfId}})
  }
}

// 관심 기업 관심여부
const onClickCorpYn = async (ojfId, corpId, inteYn) => {
  let message, okButtonText;
  if (inteYn === 'N') {
    message = ["관심기업을 등록하시겠습니까?"];
    okButtonText = "관심기업 등록";
    inteYn = "Y"
  } else {
    message = ["관심기업을 삭제하시겠습니까?"];
    okButtonText = "관심기업 삭제";
    inteYn = "N"
  }

  const ok = await $confirm(message, okButtonText);
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      ojfId: ojfId,
      corpId: corpId,
      interestYn: inteYn,
    }

    jobFairUserService.ojfInterestCorpEntryYn(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            //const result = res.data.result;
            if (inteYn === 'Y') {
              $alert("등록하였습니다.");
              corpLikeTxts.value = "♥관심기업";
              commonDatas.value = "Y";
            } else {
              $alert("삭제하였습니다.");
              corpLikeTxts.value = "♡관심기업";
              commonDatas.value = "N";
            }
          } else {
            $alert("실패하였습니다.");
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      $alert("실패하였습니다.");
    });
  }
}

// 채용공고 보기
const onClickJobNotice = async (jobNoticeSeq, corpId, ojfId) => {

  let paramObj = {
    jobNoticeSeq: jobNoticeSeq,
  }

  jobFairUserService.ojfInterestJobNoticeYn(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          jobNoticeModal.value.init(false, true, false, ojfId, 0, result, undefined, undefined, undefined, modes.value);
          jobNoticeModal.value.ojfCropJobNoticeDetail(jobNoticeSeq);
          jobNoticeModal.value.ojfCorpRecruitmentHall(ojfId, corpId);
          jobNoticeModal.value.ojfCorporationDetail(corpId);
          await jobNoticeModal.value.show();

          baseModal.value.close();
          resolvePromise.value(false);
        } else {
          console.log(res);
        }
      }).catch( (res) =>  {
    loadingStore.loading = false;
    console.log(res);
  });
}

const onClickPromotionAction = async (corpId, userId) => {
  if(!isAuthenticated.value) {
    // 로그인 X
    await $alert("로그인 후 이용해주세요.");
    navigationStore.lastAccessPage = route.fullPath;
    router.push({name: 'Signin'});
    return;
  }

  if (userTypes.value === 'student') {
    const params = {
      corpId,
      userId,
    }
    mypageCorpInfoService.retrieveApplicantByUserId(params)
        .then(async (res) => {
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            apllyYns.value = result;
            if(result !== 'Y' ) {
              userMatchingResumeCreateModal.value.retrieveResumeList(corpId, viewSources.value);
              const showResult = await userMatchingResumeCreateModal.value.show();
              if (showResult === false) {
                baseModal.value.close();
                resolvePromise.value(false);
              }
            } else {
              $alert("이미 해당 기업에 '입사지원'을 하였습니다.")
            }
          }
        })
        .catch( (error) =>  {
          $alert(error.message);
        });
  } else {
    router.push({name: 'MyPageCorpInfoUpdate', query: { corpId } });
  }
}

const onSelectedPage = (pageNo) => {

  currentPage.value = pageNo;
  ojfGnbCorpInfoJobNoticeList(corpIds.value, ojfIds.value);
}

const show = () => {
  resetPromotionState();
  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const confirm = async () => {
  resetPromotionState();
  baseModal.value.close();
  resolvePromise.value(true);
};

const cancel = () => {
  resetPromotionState();
  baseModal.value.close();
  resolvePromise.value(false);
};

// commonData = inteYn - 구직자: 관심기업 유무
// commonData = userCorpId - 기업: 사용자의 회사아이디
const init = (showButton, showPropsButton, ojfId, commonData, masterYn, mode) => {

  // 기본값 저장
  showButtons.value = showButton; // 수정 버튼 (참가확정 기업 마스터만)
  showPropsButtons.value = showPropsButton; // 관심기업 버튼

  // 면접제안 데이터
  ojfIds.value = ojfId;

  // 관심기업 여부
  if (commonData === 'Y') {
    commonData = 'Y';
    corpLikeTxts.value = "♥관심기업"
  } else if (commonData === 'N') {
    commonData = 'N';
    corpLikeTxts.value = "♡관심기업"
  }
  commonDatas.value = commonData;

  // 회원 마스터 유무
  masterYns.value = masterYn;

  // 모드 저장
  modes.value = mode;
}

defineExpose({
  show,
  init,
  ojfCorporationDetail,
  ojfGnbCorpInfoJobNoticeList,
  retrieveCorporation,
  matchingCorporationDetail
})
</script>

<template>
  <Modal ref="baseModal" class="vld-parent">
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-body">
        <MyPageCorpJobFairCorpInfoView ref="modalBody"/>
        <!-- s : 채용 공고 목록 -->
        <div v-if="viewSources !== 'promotion'" class="mt-sm gray-bg">
          <div class="resume-wrap">
            <section>
              <h2 class="mb-sm">채용 공고</h2>
              <div class="table-form">
                <table class="table-form vertical" v-if="jobNoticeList !== null">
                  <tr>
                    <th>채용 공고 제목</th>
                    <th>관심 카테고리</th>
                  </tr>
                  <tr v-for="list in jobNoticeList">
                    <td class="link blue" @click="onClickJobNotice(list.jobNoticeSeq, list.corpId, ojfIds)">{{ list.jobName }}</td>
                    <td>{{ list.interests }}</td>
                  </tr>
                </table>
              </div>
            </section>
          </div>
          <Paginate
              v-if="jobNoticeList.length > 0"
              v-model="currentPage"
              :page-count="totalPages"
              :click-handler="onSelectedPage"
          />
        </div>
        <!-- e : 채용 공고 목록 -->
      </div>
      <div v-if="viewSources === 'promotion'" class="modal-footer btn-wrap">
        <KSAPrimaryButton
            v-if="userTypes === 'student' || userTypes === 'company' || userTypes === 'none'"
            :text="userTypes === 'company' ? '수정' : (apllyYns === 'Y' ? '지원완료' : '입사지원')"
            :disabled="apllyYns === 'Y'"
            @click="onClickPromotionAction(corpIds, userIds)"
            style="margin-left: auto"
        />
      </div>
      <div v-if="showButtons && commonDatas === corpIds && masterYns === 'Y'" class="modal-footer btn-wrap">
        <KSAPrimaryButton text="수정" @click="onClickCorpUpdate(ojfIds, modes)" style="margin-left: auto" />
      </div>
      <div v-if="showPropsButtons" class="modal-footer btn-wrap">
        <!-- 관심기업 -->
        <KSASecondaryButton :text="corpLikeTxts" @click="onClickCorpYn(ojfIds, corpIds, commonDatas)" class="red_button"/>
      </div>
    </div>
  </Modal>
  <JobFairJobNoticeModal ref="jobNoticeModal" v-if="!props.inactiveInnerModal"/> <!-- 채용공고 보기 -->
  <UserMatchingResumeCreateModal ref="userMatchingResumeCreateModal" v-if="!props.inactiveInnerModal"/> <!-- 이력서 선택 -->

</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
.modal-inner {
  margin-top: 50px;
  .close {
    top: -20px !important;
  }
  .file, .link {
    color: $blue_color;
    cursor: pointer;
  }
  .link {
    color: $blue_color;
    text-decoration: underline;
  }
  .gray-bg {
    background: $gray-thin_color;
    padding: 30px;
  }
  .modal-footer {
    padding: 0 30px;
  }
}
</style>